<template>
    <div v-if="marker">
        <template>
            <slot :stopId="stop.stopId" />
        </template>
    </div>
</template>

<script>
import { ref, toRefs, inject, computed, watch } from '@vue/composition-api';
import { MapBoxMixin } from '@/mixins/MapBoxMixin';
import { MarkerPins } from '@/utils/MarkerPins';
import { MarkerColorCode } from '@/utils/MarkerColorCode';

export default {
    name: 'StopMarker',
    mixins: [MapBoxMixin],
    props: {
        publicUserId: {
            type: String,
            required: true
        },
        driver: {
            type: Object,
            default: () => {}
        },
        stop: {
            type: Object,
            default: () => {}
        },
        stopOrder: {
            type: Number,
            default: 0
        },
        markers: {
            type: Array,
            default: () => {}
        },
        minDistance: {
            type: Number,
            default: 0
        }
    },
    data() {
        return {
            markerPins: {},
            markerGeojson: {
                type: 'FeatureCollection',
                features: []
            }
        };
    },
    setup(props) {
        const { stop } = props;
        const { minDistance } = toRefs(props);
        const { getters } = inject('vuex-store');
        const map = inject('map');

        const pinnedUser = computed(() => getters['map/pinnedUser']);

        const {
            // stopId,
            location: { latitude, longitude },
            status,
            distance
        } = stop;
        const circleIcon = null;
        const isActiveStop = ['complete', 'cancelled', 'failed', 'on hold'].indexOf(status.toLowerCase()) === -1;

        const marker = ref(null);

        const changeIcon = (originalIcon, toChange) => {
            return Object.assign({}, originalIcon, toChange);
        };

        watch(minDistance, (newVal) => {
            const bounds = map.value.getBounds();
            if (!bounds.contains(marker.value.getLngLat())) 
                return true;

            if (newVal > distance) {
                marker.value.setIcon(circleIcon);
                marker.value.setLabel(null);
            }

            return true;
        });

        return {
            marker,
            map,
            distance,
            longitude,
            latitude,
            changeIcon,
            pinnedUser,
            isActiveStop
        };
    },
    render: () => null,
    watch: {
        async pinnedUser(newVal) {
            this.toggleStopMarker(newVal);
        }
    },
    beforeUnmount() {
        this.removeMarker();
    },
    methods: {
        fitBounds(bounds) {
            const coordinates = this.$_mapBox_getMaxBounds(bounds);
            this.$_mapBox_callMapFunction(this.map, 'fitBounds', coordinates, false);
        },
        toggleStopMarker(pinnedUser) {
            if (!pinnedUser && this.marker) {
                if (!this.isActiveStop) {
                    this.removeMarker();
                }

                this.addMarker();
            } else if (this.marker) {
                if (pinnedUser === this.publicUserId) {
                    this.addMarker();
                } else {
                    this.removeMarker();
                }

                // Wait for a couple of ms before applying new bounds
                setTimeout(() => this.fitBounds(this.markers.map((x) => [x.getLngLat().lng, x.getLngLat().lat])), 700);
            }
        },
        showMarker() {
            this.markerPins = Object.assign(this.markerPins, {
                [this.stop.stopId]: MarkerColorCode[this.stopOrder % MarkerColorCode.length]
            });

            const randomIndex = Math.floor(Math.random() * MarkerPins.length);
            this.markerPins[this.stop.stopId].driver = MarkerPins[randomIndex].driver;

            this.marker = this.$_mapBox_setMarkers(
                this.map,
                this.stop.location.latitude,
                this.stop.location.longitude,
                'stop',
                this.markerPins[this.stop.stopId],
                this.stopOrder + 1
            );

            this.marker.stopId = this.stop.stopId;
            this.marker.location = this.stop.location;

            if (this.isActiveStop) {
                if (this.pinnedUser) 
                    this.addMarker();
                else 
                    this.addMarker();
            }

            this.marker.getElement().addEventListener('click', () => {
                this.$root.$emit('marker-clicked', { data: this.stop, marker: this.marker, type: 'stop' });
            });

            this.toggleStopMarker(this.pinnedUser);
        },
        addMarker() {
            if (!this.markers.some((x) => x.stopId === this.marker.stopId)) {
                this.markers.push(this.marker);

                this.$_mapBox_addMapElement(this.marker, this.map);
            }
        },
        removeMarker() {
            this.$emit('deleteMarker', this.marker);
        }
    },
    mounted() {
        this.showMarker();
    }
};
</script>
